import * as React from "react";

export default function IconTabMembers() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="14" fill="#F6F6F6" />
      <g clipPath="url(#clip0_4404_9528)">
        <path
          d="M17.3333 20V18.6667C17.3333 17.9594 17.0523 17.2811 16.5522 16.781C16.0521 16.281 15.3739 16 14.6666 16H9.33329C8.62605 16 7.94777 16.281 7.44767 16.781C6.94758 17.2811 6.66663 17.9594 6.66663 18.6667V20"
          stroke="#0D47A1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.3333C13.4728 13.3333 14.6667 12.1394 14.6667 10.6667C14.6667 9.19391 13.4728 8 12 8C10.5273 8 9.33337 9.19391 9.33337 10.6667C9.33337 12.1394 10.5273 13.3333 12 13.3333Z"
          stroke="#0D47A1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3334 20V18.6667C21.3329 18.0758 21.1363 17.5019 20.7743 17.0349C20.4123 16.5679 19.9055 16.2344 19.3334 16.0867"
          stroke="#90AAD4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6666 8.08667C17.2402 8.23354 17.7487 8.56714 18.1117 9.03488C18.4748 9.50262 18.6719 10.0779 18.6719 10.67C18.6719 11.2621 18.4748 11.8374 18.1117 12.3051C17.7487 12.7729 17.2402 13.1065 16.6666 13.2533"
          stroke="#90AAD4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4404_9528">
          <rect width="16" height="16" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  );
}
